module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-04.45fed16c.png";